import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

type Props = {
  title?: string;
  description: string;
  visible: boolean;
  cancel?: string;
  ok: string;
  onConfirm: () => void;
  onCancel?: () => void;
};

export default function PopupMessage(props: Props) {
  const handleClose = () => {
    if (props.onCancel) {
      props.onCancel();
    }
  };

  return (
    <div>
      <Dialog
        open={props.visible}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{props.title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {props.description}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {props.cancel && props.onCancel &&(
            <Button onClick={handleClose}>{props.cancel}</Button>
          )}
          <Button
            onClick={() => {
              props.onConfirm();
            }}
            autoFocus
          >
            {props.ok}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
